import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/auth/ProtectedRoute';

const AdminDashboard = lazy(() => import('./AdminDashboard'));
const SubscriptionManagement = lazy(() => import('./SubscriptionManagement'));
const SubscribedCustomers = lazy(() => import('./SubscribedCustomers'));
const SubscriptionPlans = lazy(() => import('./SubscriptionPlans'));
const RevenueAnalytics = lazy(() => import('../SuperAdmin/RevenueAnalytics'));
const RegistrationLeadManagement = lazy(() => import('../SuperAdmin/RegistrationLeadManagement'));
const PricingManagement = lazy(() => import('../SuperAdmin/PricingManagement'));
const CouponManagement = lazy(() => import('../SuperAdmin/CouponManagement'));
const PartnerManagement = lazy(() => import('../SuperAdmin/PartnerManagement'));
const AdminPartnerWithdrawals = lazy(() => import('../SuperAdmin/AdminPartnerWithdrawals'));
const AdminPartnerDeals = lazy(() => import('../SuperAdmin/AdminPartnerDeals'));
const AdminPartnerHelpdesk = lazy(() => import('../SuperAdmin/AdminPartnerHelpdesk'));
const AdminSLAPolicies = lazy(() => import('../SuperAdmin/AdminSLAPolicies'));
const ApiAccessManagement = lazy(() => import('./ApiAccessManagement'));
const AdminBlogs = lazy(() => import('../SuperAdmin/AdminBlogs'));
const ContactManagement = lazy(() => import('../SuperAdmin/ContactManagement'));
const DocumentVerification = lazy(() => import('./DocumentVerification'));

const Users = lazy(() => import('./Users'));
const Roles = lazy(() => import('./Roles'));
const Settings = lazy(() => import('./Settings'));
const CompanyManagement = lazy(() => import('./CompanyManagement'));
const CurrencyManagement = lazy(() => import('./CurrencyManagement'));
const ApiSettings = lazy(() => import('./ApiSettings'));
const DataImport = lazy(() => import('./DataImport'));
const DataExport = lazy(() => import('./DataExport'));
const Notifications = lazy(() => import('./Notifications'));
const ManageSubscription = lazy(() => import('./ManageSubscription'));
const SubscriptionSettings = lazy(() => import('./SubscriptionSettings'));
const BillingHistory = lazy(() => import('./BillingHistory'));
const POSHardwareSettings = lazy(() => import('./POSHardwareSettings'));

// Settings moved from Profile
const AdminSecuritySettings = lazy(() => import('./AdminSecuritySettings'));
const CompanySettings = lazy(() => import('../Settings/CompanySettings'));
const ApiAccessSettings = lazy(() => import('../Settings/ApiAccessSettings'));

export const adminRoutes = (
    <React.Fragment key="admin">
        <Route element={<ProtectedRoute permission="admin.superadmin.view" />}>
            <Route path="/superadmin" element={<AdminDashboard />} />
            <Route path="/admin/subscriptions" element={<SubscriptionManagement />} />
            <Route path="/admin/subscriptions/customers" element={<SubscribedCustomers />} />
            <Route path="/admin/subscriptions/plans" element={<SubscriptionPlans />} />
            <Route path="/admin/revenue" element={<RevenueAnalytics />} />
            <Route path="/admin/leads" element={<RegistrationLeadManagement defaultLeadType="REGISTRATION" />} />
            <Route path="/admin/demo-requests" element={<RegistrationLeadManagement defaultLeadType="DEMO" />} />
            <Route path="/admin/pricing" element={<PricingManagement />} />
            <Route path="/admin/coupons" element={<CouponManagement />} />
            <Route path="/admin/partners" element={<PartnerManagement />} />
            <Route path="/admin/partners/withdrawals" element={<AdminPartnerWithdrawals />} />
            <Route path="/admin/partners/deals" element={<AdminPartnerDeals />} />
            <Route path="/admin/partners/helpdesk" element={<AdminPartnerHelpdesk />} />
            <Route path="/admin/partners/sla" element={<AdminSLAPolicies />} />
            <Route path="/admin/api-access" element={<ApiAccessManagement />} />
            <Route path="/admin/blog" element={<AdminBlogs />} />
            <Route path="/admin/contact-messages" element={<ContactManagement />} />
        </Route>

        {/* ADMINISTRATION (moved from Settings) */}
        <Route element={<ProtectedRoute permission="admin.user.view" />}>
            <Route path="/admin/users" element={<Users />} />
            <Route path="/admin/roles" element={<Roles />} />
        </Route>
        <Route element={<ProtectedRoute permission="admin.settings.manage" />}>
            <Route path="/admin/settings" element={<Settings />} />
            <Route path="/admin/companies" element={<CompanyManagement />} />
            <Route path="/admin/currencies" element={<CurrencyManagement />} />
            <Route path="/admin/document-verification" element={<DocumentVerification />} />
            <Route path="/admin/data-import" element={<DataImport />} />
            <Route path="/admin/data-export" element={<DataExport />} />
            <Route path="/admin/notifications" element={<Notifications />} />
            <Route path="/admin/subscription" element={<ManageSubscription />} />
            <Route path="/admin/subscription/settings" element={<SubscriptionSettings />} />
            <Route path="/admin/billing-history" element={<BillingHistory />} />
            <Route path="/admin/security" element={<AdminSecuritySettings />} />
            <Route path="/admin/business-settings" element={<CompanySettings />} />
            <Route path="/admin/api-integrations" element={<ApiAccessSettings />} />
            <Route path="/admin/pos-hardware" element={<POSHardwareSettings />} />
        </Route>
    </React.Fragment>
);

